import { ImageOff, MousePointerClick } from "lucide-react";
import { useTranslation } from "react-i18next";

// One numbered micro-step: short text, the button to press highlighted, and the real screenshot — or an explicit placeholder (never a fake image).
function Shot({ s, n }) {
  const { t, i18n } = useTranslation("help");
  if (s.image) return (
    <figure className="mt-3" data-testid={`help-shot-${n}`}>
      <img src={`/help/${s.image}`} alt={t("shot_alt", { n, text: s.text })} loading="lazy" className="h-auto w-auto max-w-full rounded-lg border border-slate-200" />
      {!i18n.language?.startsWith("it") && <figcaption className="mt-1 text-[11px] text-slate-500" data-testid={`help-shot-note-${n}`}>{t("shot_ui_note")}</figcaption>}
    </figure>);
  if (!s.shot) return null;
  return (
    <div className="mt-3 flex items-center gap-3 rounded-lg border border-dashed border-slate-300 bg-slate-50 p-4 text-xs text-slate-500" role="note" data-testid={`help-shot-placeholder-${n}`}>
      <ImageOff size={18} aria-hidden="true" className="shrink-0" /><span><b className="block text-slate-600">{t("shot_missing")}</b>{t("shot_missing_hint")}</span>
    </div>);
}

export function GuideSteps({ steps }) {
  const { t } = useTranslation("help");
  return (
    <ol className="space-y-4" data-testid="help-steps">
      {steps.map((s, i) => (
        <li key={i} className="rounded-xl border border-slate-200 bg-white p-4 sm:p-5" data-testid={`help-step-${i + 1}`}>
          <div className="flex gap-3">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-900 text-sm font-semibold text-white" aria-hidden="true">{i + 1}</span>
            <div className="min-w-0 flex-1">
              <p className="text-[11px] font-medium uppercase tracking-wide text-slate-400">{t("step", { n: i + 1, total: steps.length })}</p>
              <p className="mt-0.5 text-base leading-relaxed text-slate-800">{s.text}</p>
              {s.click && <p className="mt-2 inline-flex flex-wrap items-center gap-1.5 text-xs text-slate-600"><MousePointerClick size={14} aria-hidden="true" />{t("click")}
                <kbd className="rounded-md border border-amber-300 bg-amber-50 px-2 py-0.5 font-sans text-xs font-semibold text-amber-900" data-testid={`help-click-${i + 1}`}>{s.click}</kbd></p>}
            </div>
          </div>
          <Shot s={s} n={i + 1} />
        </li>))}
    </ol>);
}
